import React from 'react';
import UIThreeColumnWrapper from '@/components/shared/UIThreeColumnWrapper';
import TodayTable from '../TodayTable';
import './TodayTablesSection.scss';

// Типи для різних таблиць
export interface PaymentData {
  id: string;
  tenant: {
    name: string;
    email: string;
    avatar: string;
  };
}

export interface VacancyData {
  id: string;
  property: {
    name: string;
    type: 'RESIDENTIAL' | 'COMMERCIAL';
  };
  unit: string;
}

export interface TaskData {
  id: string;
  task: string;
  type: 'Plumbing' | 'Electricity' | 'Maintenance' | 'Other';
}

interface TodayTablesSectionProps {
  paymentData?: PaymentData[];
  vacancyData?: VacancyData[];
  taskData?: TaskData[];
  onViewAllPayments?: () => void;
  onViewAllVacancies?: () => void;
  onViewAllTasks?: () => void;
}

// Мок-дані
const mockPaymentData: PaymentData[] = [
  {
    id: '1',
    tenant: {
      name: 'Frank Mitchell',
      email: 'frank@example.com',
      avatar: '/images/avatar1.jpg'
    }
  },
  {
    id: '2',
    tenant: {
      name: 'Woo Chang',
      email: 'chang@example.com',
      avatar: '/images/avatar2.jpg'
    }
  },
  {
    id: '3',
    tenant: {
      name: 'Amanda Stevenson',
      email: 'donec@example.com',
      avatar: '/images/avatar3.jpg'
    }
  },
  {
    id: '4',
    tenant: {
      name: 'Adam Patel',
      email: 'ipsum@example.com',
      avatar: '/images/avatar4.jpg'
    }
  },
  {
    id: '5',
    tenant: {
      name: 'Ron Chambers',
      email: 'ron@example.com',
      avatar: '/images/avatar5.jpg'
    }
  }
];

const mockVacancyData: VacancyData[] = [
  { id: '1', property: { name: 'Arbre Magique', type: 'RESIDENTIAL' }, unit: '203' },
  { id: '2', property: { name: 'Arbre Magique', type: 'RESIDENTIAL' }, unit: '204' },
  { id: '3', property: { name: 'Arbre Magique', type: 'RESIDENTIAL' }, unit: '205' },
  { id: '4', property: { name: 'Arbre Magique', type: 'RESIDENTIAL' }, unit: '206' },
  { id: '5', property: { name: 'Arbre Magique', type: 'RESIDENTIAL' }, unit: '207' }
];

const mockTaskData: TaskData[] = [
  { id: '1', task: 'Plumbing', type: 'Plumbing' },
  { id: '2', task: 'Electricity', type: 'Electricity' },
  { id: '3', task: 'Electricity', type: 'Electricity' },
  { id: '4', task: 'Plumbing', type: 'Plumbing' },
  { id: '5', task: 'Plumbing', type: 'Plumbing' }
];

const mockHandlers = {
  onViewAllPayments: () => console.log('View all payments'),
  onViewAllVacancies: () => console.log('View all vacancies'),
  onViewAllTasks: () => console.log('View all tasks')
};

const TodayTablesSection: React.FC<TodayTablesSectionProps> = ({
                                                                 paymentData = mockPaymentData,
                                                                 vacancyData = mockVacancyData,
                                                                 taskData = mockTaskData,
                                                                 onViewAllPayments = mockHandlers.onViewAllPayments,
                                                                 onViewAllVacancies = mockHandlers.onViewAllVacancies,
                                                                 onViewAllTasks = mockHandlers.onViewAllTasks
                                                               }) => {
  return (
    <UIThreeColumnWrapper
      gap="medium"
      equalHeight={true}
      mobileLayout="stack"
      spacing="tight"
      background="transparent"
      shadow="none"
    >
      {[
        <TodayTable
          title="Today's payment"
          type="payment"
          data={paymentData}
          onViewAll={onViewAllPayments}
        />,
        <TodayTable
          title="Today's vacancy"
          type="vacancy"
          data={vacancyData}
          onViewAll={onViewAllVacancies}
        />,
        <TodayTable
          title="Today's tasks"
          type="task"
          data={taskData}
          onViewAll={onViewAllTasks}
        />
      ]}
    </UIThreeColumnWrapper>
  );
};

export default TodayTablesSection;